<template>
  <div>
    <div class="account-node" :class="{ 'account-node--inactive': !node.active }" :style="{ paddingLeft: (level * 22 + 8) + 'px' }" @click="onRowClick">
      <span class="account-node__toggle">
        <AppIcon v-if="node.children.length" :name="isOpen ? 'expand_more' : 'chevron_right'" />
      </span>
      <AppIcon class="account-node__icon" :name="node.children.length ? 'folder' : 'description'" />
      <span class="account-node__code">{{ node.code }}</span>
      <span class="account-node__name" :class="{ 'font-weight-bold': node.children.length }">{{ node.name }}</span>

      <span class="account-node__chips">
        <span class="account-node__chip" v-if="node.reference">{{ node.reference }}</span>
        <span class="account-node__chip account-node__chip--used" v-for="use in uses(node.id)" :key="use" v-b-tooltip.hover :title="'Cuenta por defecto de ' + use">{{ use }}</span>
        <span class="account-node__chip account-node__chip--warning" v-if="!node.active">Inactiva</span>
        <span class="account-node__chip account-node__chip--warning" v-if="parentType && node.type != parentType" v-b-tooltip.hover :title="'Es de tipo ' + node.type + ' y su grupo de tipo ' + parentType + '. El cierre usa el tipo de cada cuenta.'">Tipo distinto</span>
      </span>

      <span class="account-node__actions" @click.stop>
        <b-button variant="link" class="list-view-icon-btn" v-b-tooltip.hover title="Agregar subcuenta" aria-label="Agregar subcuenta" @click="$emit('add-child', node)"><AppIcon name="add" /></b-button>
        <b-button variant="link" class="list-view-icon-btn" v-b-tooltip.hover title="Editar" aria-label="Editar" @click="$emit('edit', node)"><AppIcon name="edit" /></b-button>
        <b-button variant="link" class="list-view-icon-btn" v-b-tooltip.hover title="Borrar" aria-label="Borrar" @click="$emit('remove', node)"><AppIcon name="delete" /></b-button>
      </span>
    </div>

    <template v-if="isOpen">
      <AccountTreeNode v-for="child in node.children" :key="child.id" :node="child" :level="level + 1" :parent-type="node.type"
                       :expanded="expanded" :force-open="forceOpen" :uses="uses"
                       @toggle="$emit('toggle', $event)" @add-child="$emit('add-child', $event)" @edit="$emit('edit', $event)" @remove="$emit('remove', $event)" />
    </template>
  </div>
</template>

<script>
  export default {
    name: 'AccountTreeNode',
    props: {
      node: { type: Object, required: true },
      level: { type: Number, default: 0 },
      parentType: { type: String, default: '' },
      expanded: { type: Object, required: true },
      forceOpen: { type: Boolean, default: false },
      uses: { type: Function, required: true },
    },
    computed: {
      isOpen() {
        return this.forceOpen || !!this.expanded[this.node.id]
      },
    },
    methods: {
      onRowClick() {
        if(this.node.children.length) {
          this.$emit('toggle', this.node.id)
        } else {
          this.$emit('edit', this.node)
        }
      },
    },
  }
</script>

<style scoped>
  .account-node {
    display: flex;
    align-items: center;
    gap: 6px;
    min-height: 36px;
    padding-right: 8px;
    border-bottom: 1px solid var(--app-color-border);
    cursor: pointer;
  }
  .account-node:hover {
    background: var(--app-color-primary-soft);
  }
  .account-node--inactive .account-node__name,
  .account-node--inactive .account-node__code {
    color: var(--app-color-text-muted);
    text-decoration: line-through;
  }
  .account-node__toggle {
    display: inline-flex;
    justify-content: center;
    width: 20px;
    flex-shrink: 0;
    color: var(--app-color-text-secondary);
  }
  .account-node__icon {
    flex-shrink: 0;
    color: var(--app-color-icon);
  }
  .account-node__code {
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 600;
    color: var(--app-color-text-secondary);
  }
  .account-node__name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .account-node__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-left: 6px;
  }
  .account-node__chip {
    padding: 0 7px;
    border-radius: 9px;
    font-size: 11px;
    line-height: 18px;
    white-space: nowrap;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-secondary);
  }
  .account-node__chip--used {
    background: var(--app-color-info-soft);
    color: var(--app-color-info);
  }
  .account-node__chip--warning {
    background: var(--app-color-warning-soft);
    color: var(--app-color-warning);
  }
  .account-node__actions {
    display: flex;
    margin-left: auto;
    flex-shrink: 0;
    opacity: 0;
  }
  .account-node:hover .account-node__actions,
  .account-node__actions:focus-within {
    opacity: 1;
  }
  @media (max-width: 767.98px) {
    .account-node__actions {
      opacity: 1;
    }
    .account-node {
      flex-wrap: wrap;
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
</style>
